import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { ButtonIcon } from 'platfi-ui-components';

import { bemClassName } from 'utils/BEMHelper';

import styles from './ShareableReportSubSection.scss';

const ShareableReportSubSection = (props) => {
  const { reference, title, hidden, children, hiddenOnPrint, onHiddenToggle, isHideToggleVisible } =
    props;

  const headerStyleName = bemClassName('m-shareable-report-sub-section__header', { hidden });
  const toggleStyleName = bemClassName('m-shareable-report-sub-section__hide-toggle', { hidden });
  const containerStyleName = bemClassName('m-shareable-report-sub-section', {
    hidden,
    'hide-on-print': hiddenOnPrint,
  });

  return (
    <div styleName={containerStyleName}>
      <div styleName="m-shareable-report-sub-section__header-container">
        <div ref={reference} styleName={headerStyleName}>
          <div styleName="m-shareable-report-sub-section__title">{title}</div>
          {isHideToggleVisible && (
            <ButtonIcon
              onClick={onHiddenToggle}
              icon={hidden ? 'eye' : 'eye_private'}
              label={hidden ? 'Show Section' : 'Hide Section'}
              iconRight
              small
              styleName={toggleStyleName}
            />
          )}
        </div>
      </div>
      {children}
    </div>
  );
};

ShareableReportSubSection.propTypes = {
  title: PropTypes.string.isRequired,
  hidden: PropTypes.bool,
  reference: PropTypes.object,
  hiddenOnPrint: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onHiddenToggle: PropTypes.func,
  isHideToggleVisible: PropTypes.bool,
};

ShareableReportSubSection.defaultProps = {
  hiddenOnPrint: false,
  isHideToggleVisible: true,
};

export default CSSModules(ShareableReportSubSection, styles, {
  allowMultiple: true,
});
